
const authPath = {
  login: "/login",
  signup: "/signup",
  reset: "/restore/:token",
};
export default authPath;
